import { Outlet } from "react-router-dom";

export function AppFacilityFrame() {    
    return <Outlet />;
}